var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#081327"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57666 4.52512C6.38519 4.40829 6.14771 4.40829 5.95623 4.52512L4.42663 5.45844C4.23975 5.57247 4.125 5.78057 4.125 6.00547V7.879C4.125 8.1039 4.23975 8.31201 4.42663 8.42604L5.95623 9.35935C6.14771 9.47619 6.38519 9.47619 6.57666 9.35935L9.73355 7.43312L11.0592 8.24199V9.87353L9.73355 10.6824L8.4079 9.87353V8.84621L7.59211 9.37509V9.99452C7.59211 10.2194 7.70685 10.4275 7.89373 10.5416L9.42334 11.4749C9.61481 11.5917 9.85229 11.5917 10.0438 11.4749L11.5734 10.5416C11.7603 10.4275 11.875 10.2194 11.875 9.99452V8.121C11.875 7.8961 11.7603 7.68799 11.5734 7.57396L10.0438 6.64065C9.85229 6.52381 9.61481 6.52381 9.42334 6.64065L6.26645 8.56688L4.94079 7.75801V6.12647L6.26645 5.3176L7.59211 6.12647V7.15379L8.4079 6.62492V6.00547C8.4079 5.78057 8.29315 5.57247 8.10627 5.45844L6.57666 4.52512Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "border",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#36F7D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.55053d0fe50f7c63c98cdd7d7c6bb016.svg";
export { ForwardRef as ReactComponent };